import { useLocale } from "next-intl";
import { LangItem } from "./LangItem";
import { useEffect, useState } from "react";

export const LangSwitcher = () => {
  const [lang, setLang] = useState<string | null>(null);

  useEffect(() => {
    const getLangCookie = () => {
      const match = document.cookie.match(/(^| )lang=([^;]+)/);
      return match ? match[2] : null;
    };

    setLang(getLangCookie());
  }, []);

  const locale = useLocale();

  if (!!lang) {
    return (
      <div>
        {locale === "en" && <LangItem label="English" locale="en" noSelector />}
        {locale === "zh-CN" && (
          <LangItem label="中文 (简体)" locale="zh-CN" noSelector />
        )}
        {locale === "zh-TW" && (
          <LangItem label="中文 (繁體)" locale="zh-TW" noSelector />
        )}
      </div>
    );
  }

  return (
    <div>
      <LangItem label="English" locale="en" />
      <LangItem label="中文 (简体)" locale="zh-CN" />
      <LangItem label="中文 (繁體)" locale="zh-TW" />
    </div>
  );
};
